import { SizableText, XStack, YStack } from '@my/ui'
import { UserAvatar } from 'app/features/user/components'
import { formatTimeToNow } from 'app/utils/format-time-to-now'
import { PostUserProps } from './post-user-props'
import { useState } from 'react'
import { UserPopup } from '../../containers'

export const PostUser = ({ creator, createdAt, editedAt }: PostUserProps) => {
  const [userOpen, setUserOpen] = useState(false)

  if (!createdAt || !creator) {
    return null
  }

  const formattedTime = formatTimeToNow(createdAt)
  return (
    <XStack
      cursor="pointer"
      flexShrink={1}
      gap="$2"
      tag="button"
      aria-label="Open user popup"
      onPress={() => setUserOpen(true)}
      pressStyle={{
        opacity: 0.75,
      }}
      focusStyle={{
        opacity: 0.8,
      }}
      hoverStyle={{
        opacity: 0.8,
      }}
    >
      <UserAvatar
        flexShrink={0}
        width={44}
        height={44}
        src={creator?.avatar?.small}
        rounded={false}
      />
      <YStack flexShrink={1}>
        <SizableText
          numberOfLines={1}
          size="$4"
          fow="600"
          $gtSm={{ size: '$5', fow: '600' }}
        >
          {creator.fullName}
        </SizableText>
        <XStack flexShrink={1} flexWrap="wrap" rowGap="$1" columnGap="$2" ai="center">
          {creator?.university && (
            <SizableText numberOfLines={1} color="$offBlack" size="$1">
              {creator?.university.name}
            </SizableText>
          )}
          <SizableText color="$gray11" size="$1">
            {formattedTime} {editedAt && '· Edited'}
          </SizableText>
        </XStack>
      </YStack>

      {userOpen && <UserPopup user={creator} open={userOpen} onOpenChange={setUserOpen} />}
    </XStack>
  )
}
